import React, { Component } from 'react'
import FormButtonPanel from './utilities/FormButtonPanel'
import { connect } from 'react-redux'
import { editEndpointList } from '../actions/endpoints'
import { withRouter } from 'react-router'
import moment from 'moment'

class NewIntegrationForm extends Component{
    constructor(props){
        super(props)
        this.state = {
            name: '',
            description: '',
            handler: '',
            fromProvider: '',
            toProvider: '',
            fromDatasource: '',
            toDatasource: '',
            errors: {},
            isSubmitting: false
        }
        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.verifyOptions = this.verifyOptions.bind(this)
        this.validate = this.validate.bind(this)
    }

    handleChange( e ){
        this.setState({
            [ e.target.name ]: e.target.value
        },()=>{
            if(Object.keys(this.state.errors).length){
                this.validate()
            }
        })
    }

    validate(){
        let nameRestriction = /^[a-zA-Z0-9-_]+$/
        let hasErrors = false
        let errors = {}
        if( !Number(this.state.fromDatasource) ){
            errors.fromDatasource = 'This field is required'
            hasErrors = true
        } 
        if ( !Number(this.state.toDatasource) ) {
            errors.toDatasource = 'This field is required'
            hasErrors = true
        }
        if ( !this.state.name ){
            errors.name = 'This field is required'
            hasErrors = true
        } else if ( !nameRestriction.test(this.state.name) ){
            errors.name = 'Special characters and spaces not allowed'
            hasErrors = true
        }
        if ( !this.state.description ){
            errors.description = 'This field is required'
            hasErrors = true
        }
        if ( !this.state.handler ){
            errors.handler = 'This field is required'
            hasErrors = true
        }   

        this.setState({errors})
        return hasErrors
    }

    handleSubmit( e ){
        e.preventDefault()
        let { dispatch, auth, history, parentUrl } = this.props
        let ac = auth.access_token
        
        // Create a datasource mapping.
        let dsm = {
            datasource_id: Number(this.state.fromDatasource),
            datatarget_id: Number(this.state.toDatasource),
            remarks: null
        }

        // Create a task data.
        let tsk = {
            name: this.state.name,
            description: this.state.description,
            handler: this.state.handler,
            status: 0
        }

        // Create a schedule data.
        let skd = {
            name: this.state.name,
            description: this.state.description,
            status: 0,
            remarks: '',
            // start_date: new Date().toISOString().slice(0, 19).replace('T', ' '),
            start_date: moment().format('YYYY-MM-DD').toString(),
            // end_date: "2028/01/01 00:00:00",
            end_date: moment().add(10,'year').format('YYYY-MM-DD').toString(),
            start_time: "00:00:00",
            priority: 1,
            frequency_id: null,
            queue_no: 1
        }
        
        if(this.validate()){
            return false
        }
        
        this.setState({
            isSubmitting: true
        },()=>{
            // Create datasourcemapping
            dispatch(editEndpointList(11, 'datasourcemappings', ac, dsm))
            .then( resObj => {
                // take the newly created datasourcemapping and create the task/integration
                if( resObj.response.ok) {
                    return resObj.json.then( data => {
                        tsk['options'] = '{"type":"integration","datasourcemapping_id":'+ data.id +'}'
                        return dispatch(editEndpointList( 1, 'tasks', ac, tsk))
                    })
                } else {
                    this.setState({
                        isSubmitting: false
                    })
                }
            }).then( resObj2 => {
                // take the newly created task/integration and create the schedule, assign the task_id field
                if( resObj2 && resObj2.response.ok) {
                    return resObj2.json.then( createdIntegration => {
                        tsk['id'] = createdIntegration.id
                        skd['task_id'] = createdIntegration.id
                        return dispatch(editEndpointList(2, 'schedules', ac, skd))
                    })
                } else {
                    this.setState({
                        isSubmitting: false
                    })
                }
            }).then(resObj3 => {
                // take the newly created schedule and edit the integration options to include the schedule_id
                if( resObj3 && resObj3.response.ok ) {
                    return resObj3.json.then( sched => {
                        return dispatch( 
                            editEndpointList(1,'tasks',ac,Object.assign({},tsk,{options: tsk.options.replace('}',',"schedule_id":'+ sched.id +'}')})) 
                        )
                    })
                } else {
                    this.setState({
                        isSubmitting: false
                    })
                }
            }).then( resObj4 => {
                // after all have been created, push to the integrations page
                if( resObj4 && resObj4.response.ok && tsk.id ){
                    history.push(`${parentUrl}/${tsk.id}/mapping`)
                } else {
                    this.setState({
                        isSubmitting: false
                    })
                }
            })
        })
    }

    verifyOptions( n ){
        let providers = this.props.providers
        let provValue = this.state[`${n}Provider`]
        let provider = provValue ? providers.find( p => 
            p.id.toString() === provValue
        ): null

        let options = provider ? provider.options: null
        let optionsObj = null
        if( provValue && provider && options && 
            options.startsWith('{') && options.endsWith('}') && 
            options.includes('datasources') ) {
            optionsObj = JSON.parse( options )
        }
        return optionsObj || { datasources: [] }
    }

    render(){
        // Get props
        let {
            datasources
        } = this.props

        let errors = this.state.errors
        
        // Create labels
        const labels = [
            "Name",
            "Description",
            "Handler"
        ]

        const required = [
            "Name",
            "Description",
            "Handler"
        ]

        // Create form labels
        let headers = []
        let fields = []
        for( let l of labels ){
            let n = l.toLocaleLowerCase().replace(/ /g,"_")
            headers.push(
                <div className="" key={l}>
                    <div className="col-12 mt-3"  
                       
                    >
                        <div className="col-2">
                            <label htmlFor={n}>
                                {l}{required.includes(l)&&"*"}
                            </label>
                        </div>
                        <div className="col-12">
                            <input 
                                className={"form-control" + (errors && errors.hasOwnProperty(n) ? " is-invalid":"")}
                                type="text" 
                                name={n} 
                                id={n} 
                                onChange={this.handleChange} 
                                value={this.state[n]}
                            />
                            <div className="invalid-feedback">
                                {errors && errors.hasOwnProperty(n) ? errors[n] : ""}
                            </div>
                        </div>
                    </div>  
                </div>                                  
            )
        }

        // Create 'From', 'To' provider dropdowns.
            fields.push(
                <div className={`row mx-0 mt-4 pt-3`} key='Datasource-section'>
                {  
                ['From', 'To'].map(l => {
                    let n = l.toLocaleLowerCase()
                    return (
                    <div className="col-6 mt-3" key={`${l}-datasource`}>
                        <label>{`${l}: Datasource*`}</label>
                        <select onChange={this.handleChange} name={`${n}Datasource`} className={"form-control" + (errors && errors.hasOwnProperty(`${n}Datasource`) ? " is-invalid":"")}>
                            <option value="0">Select a datasource</option>
                            {
                                datasources.map( d => {
                                    let otherField = n === 'to' ? 'fromDatasource' : 'toDatasource'
                                    let hideOption = (Number(this.state[otherField]) === d.id) || !d.status
                                    return (
                                        <option key={d.id} value={d.id} className={hideOption ? "d-none":""}>
                                            {d.name}
                                        </option>
                                    )
                                })
                            }
                        </select>
                        <div className="invalid-feedback">
                            {errors && errors.hasOwnProperty(`${n}Datasource`) ? errors[`${n}Datasource`] : ""}
                        </div>
                    </div>
                    )
                })}
                </div>
            )

        return(
            <div id="working-area-content">
                <form onSubmit={this.handleSubmit}>
                    <div className="form-area-content">
                       
                        <div className="add-field-wrapper">
                            <div key="btn-panel-top" className="absolute-btn"> 
                                <FormButtonPanel 
                                    isFetching={this.props.isFetching || this.state.isSubmitting}
                                    formType="new"
                                    parentUrl="/Integrations"
                                />   
                            </div> 
                           
                        </div>
                             
                        <div className="prop-header">
                            { headers } 
                        </div>

                        <div className="prop-details">           
                            { fields }
                        </div>   
                    </div>
                </form>
            </div>
        )
    }
}

const mapStateToProps = ( state, ownProps ) => {
    return {
        parentUrl: ownProps.parentUrl,
        providers: state.endpoints.find( e => e.name === 'providers' ).list,
        datasources: state.endpoints.find( e => e.name === 'datasources' ).list,
        auth: state.auth
    }
}

export default withRouter(connect(mapStateToProps)(NewIntegrationForm))


// WEBPACK FOOTER //
// ./src/components/newIntegrationForm.js